<template>
  <div :style="`min-height: 80vh; height: 100%;`">
    <div class="container md:mx-auto mx-0 p-20 bg-white md:rounded">
      <div class="flex items-center justify-center text-center font-semibold">
        <div v-html="$t('payments.welcome')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import hubspotAPI from "../../api/hubspot"
/**
 * Define the success page
 */
export default {
  // on mount timer few seconds and redirect to home
  mounted() {
    // update rele.ai crm to product lifecycle to "Subscriber" STEP4
    if (process.env.VUE_APP_FIRE_ENV === "production") {
      this.updateSubscriberReleCrm()
    }

    // redirect to home page
    setTimeout(() => {
      this.$router.replace("/")
    }, 10000)
  },

  // computed properties
  computed: {
    ...mapGetters({
      jwt: "auth/getIdToken"
    })
  },

  // methods
  methods: {
    /**
     * Update Subscriber Rele Crm
     */
    async updateSubscriberReleCrm() {
      const api = hubspotAPI("NONE_API", this.jwt)

      return api.notify("update_subscriber_rele_crm")
    }
  }
}
</script>
